import { Dialog, Button } from '@workspace/design-system/src/components';
import { getPlanLabel } from '../constants';
interface PaymentRequestDirectSuccessDialogProps {
    channelName: string;
    planType: string;
    mode: 'apply' | 'extend';
    onClose: () => void;
}

export function PaymentRequestDirectSuccessDialog({
    channelName,
    planType,
    mode,
    onClose,
}: PaymentRequestDirectSuccessDialogProps) {
    return (
        <Dialog>
            <Dialog.Content className="max-w-[480px]">
                <Dialog.Header
                    title="직접 결제 요청이 완료되었습니다"
                    type="confirm"
                    showIcon
                />

                <Dialog.Body>
                    <div className="flex flex-col gap-3">
                        <p className="text-[14px] text-[#101010] leading-[20px] tracking-[-0.1px]">
                            입금 확인 후 결제일을 입력하면 ‘{channelName}’ 채널에 {getPlanLabel(planType)} 요금제가 {mode == 'apply' ? '적용' : '연장'}됩니다.
                        </p>

                    </div>
                </Dialog.Body>

                <Dialog.Footer className="flex gap-3 items-center justify-end">
                    <Button
                        styleType="primary"
                        styleSize="M-40"
                        onClick={onClose}
                    >
                        확인
                    </Button>
                </Dialog.Footer>
            </Dialog.Content>
        </Dialog>
    );
}

